import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SalonCard = ({ salon, onEdit, onDelete, onViewDetails }) => {
  const [showActions, setShowActions] = useState(false);

  const formatPersianNumber = (num) => {
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    return num?.toString()?.replace(/\d/g, (digit) => persianDigits?.[digit]);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'text-success bg-success/10';
      case 'maintenance':
        return 'text-warning bg-warning/10';
      case 'closed':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'active':
        return 'فعال';
      case 'maintenance':
        return 'در تعمیرات';
      case 'closed':
        return 'تعطیل';
      default:
        return 'نامشخص';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-all duration-200 relative">
      {/* Status Badge */}
      <div className="flex items-center justify-between mb-4">
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
            salon?.status
          )}`}>
          {getStatusLabel(salon?.status)}
        </span>

        <div className="relative">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setShowActions(!showActions)}
            className="h-8 w-8"
            iconName="MoreVertical"
            iconSize={16}
          />

          {showActions && (
            <div className="absolute left-0 top-full mt-1 bg-popover border border-border rounded-lg shadow-elevation-3 z-dropdown animate-fade-in">
              <div className="py-1">
                <button
                  onClick={() => {
                    onViewDetails(salon);
                    setShowActions(false);
                  }}
                  className="w-full px-3 py-2 text-right text-sm text-foreground hover:bg-muted transition-colors duration-150 flex items-center gap-2">
                  <Icon name="Eye" size={14} />
                  مشاهده جزئیات
                </button>
                <button
                  disabled
                  onClick={() => {
                    onEdit(salon);
                    setShowActions(false);
                  }}
                  className="w-full px-3 py-2 text-right text-sm text-foreground hover:bg-muted transition-colors duration-150 flex items-center gap-2">
                  <Icon name="Edit" size={14} />
                  ویرایش
                </button>
                <button
                  disabled
                  onClick={() => {
                    onDelete(salon);
                    setShowActions(false);
                  }}
                  className="w-full px-3 py-2 text-right text-sm text-error hover:bg-error/10 transition-colors duration-150 flex items-center gap-2">
                  <Icon name="Trash2" size={14} />
                  حذف
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Salon Info */}
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-foreground mb-2">
          {salon?.name}
        </h3>
        <div className="flex items-center gap-2 text-muted-foreground mb-2">
          <Icon name="MapPin" size={16} />
          <span className="text-sm">{salon?.address}</span>
        </div>
        <div className="flex items-center gap-2 text-muted-foreground">
          <Icon name="Phone" size={16} />
          <span className="text-sm">{salon?.phone}</span>
        </div>
      </div>
      {/* Statistics */}
      {/* <div className="grid grid-cols-3 gap-4 mb-4">
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">
            {formatPersianNumber(salon?.employeeCount)}
          </div>
          <div className="text-xs text-muted-foreground">کارمند</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">
            {formatPersianNumber(salon?.serviceCount)}
          </div>
          <div className="text-xs text-muted-foreground">خدمات</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">
            {formatPersianNumber(salon?.todayAppointments)}
          </div>
          <div className="text-xs text-muted-foreground">نوبت امروز</div>
        </div>
      </div> */}
      {/* Quick Actions */}
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onViewDetails(salon)}
          className="flex-1"
          iconName="Calendar"
          iconPosition="right"
          iconSize={14}>
          مدیریت نوبت‌ها
        </Button>
        <Button
          variant="default"
          size="sm"
          onClick={() => onEdit(salon)}
          className="flex-1"
          iconName="Settings"
          iconPosition="right"
          iconSize={14}>
          مدیریت سالن
        </Button>
      </div>
      {/* Backdrop for actions menu */}
      {showActions && (
        <div
          className="fixed inset-0 z-[250]"
          onClick={() => setShowActions(false)}
        />
      )}
    </div>
  );
};

export default SalonCard;
